import { useContext } from 'react';
import I18n from 'I18n';
import { useCreateMachine } from 'fsm';
import { useAlerts } from 'breeze-intelligence-kit';
import { useCurrentUser } from 'policy-lib';
import { machine } from './machine';
import { EnrichableObjectTypesContext } from './context';
import { jsx as _jsx } from "react/jsx-runtime";
export const EnrichableObjectTypeProvider = ({
  children
}) => {
  const currentUser = useCurrentUser();
  const {
    addAlertDanger,
    addAlertSuccess
  } = useAlerts();
  const enrichableObjectTypesMachine = useCreateMachine(machine, {
    initialContext: {
      addAlertDanger,
      addAlertSuccess,
      companyLabels: {
        plural: I18n.text('enrichableObjectTypes.company.plural'),
        singular: I18n.text('enrichableObjectTypes.company.singular')
      },
      contactLabels: {
        plural: I18n.text('enrichableObjectTypes.contact.plural'),
        singular: I18n.text('enrichableObjectTypes.contact.singular')
      }
    },
    isReady: currentUser.isLoaded
  });
  return /*#__PURE__*/_jsx(EnrichableObjectTypesContext.Provider, {
    value: enrichableObjectTypesMachine,
    children: children
  });
};
const capitalize = string => `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
export function useEnrichableObjectTypes() {
  const enrichableObjectTypesMachine = useContext(EnrichableObjectTypesContext);
  if (!enrichableObjectTypesMachine) {
    throw new Error('useEnrichableObjectTypes must be used within a EnrichableObjectTypeProvider');
  }
  const {
    state
  } = enrichableObjectTypesMachine;
  const {
    contactLabels,
    companyLabels
  } = state.context;
  const companyLabel = capitalize(companyLabels.singular);
  const companyLabelLowercase = companyLabel.toLowerCase();
  const companyLabelPlural = capitalize(companyLabels.plural);
  const companyLabelPluralLowercase = companyLabelPlural.toLowerCase();
  const contactLabel = capitalize(contactLabels.singular);
  const contactLabelLowercase = contactLabel.toLowerCase();
  const contactLabelPlural = capitalize(contactLabels.plural);
  const contactLabelPluralLowercase = contactLabelPlural.toLowerCase();
  return {
    companyLabel,
    companyLabelLowercase,
    companyLabelPlural,
    companyLabelPluralLowercase,
    contactLabel,
    contactLabelLowercase,
    contactLabelPlural,
    contactLabelPluralLowercase,
    isLoading: state.hasTag('loading'),
    isLoaded: state.matches('idle')
  };
}